import { render, staticRenderFns } from "./BookFinishCard.vue?vue&type=template&id=5048a610&"
import script from "./BookFinishCard.vue?vue&type=script&lang=js&"
export * from "./BookFinishCard.vue?vue&type=script&lang=js&"
import style0 from "./BookFinishCard.vue?vue&type=style&index=0&id=5048a610&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports